import { api } from "@/shared/api";

// FSD features/reporter — 新闻舱「官网栏目」(定期发布,1009 二期)。
// 契约锚点:gscq-api ReporterColumnController(base /api/v1/tenant/reporter)。
// 选题不扣费;自动生成按新闻舱现有口径扣费;生成完只到「待审」,确认后才建发布记录。

export type ColumnItemStatus =
  | "PENDING"
  | "GENERATING"
  | "REVIEW"
  | "CONFIRMED"
  | "PUBLISHED"
  | "FAILED"
  | "SKIPPED";

export type UnreviewedPolicy = "SKIP" | "POSTPONE";

export interface SiteColumn {
  id: string;
  siteId: string;
  siteName: string | null;
  /** 1009 D:站点首页地址(同名站靠域名区分)。 */
  siteUrl?: string | null;
  name: string;
  /** 1-7,1=周一。 */
  weekdays: number[];
  /** HH:mm。 */
  publishTime: string;
  totalCount: number | null;
  endDate: string | null;
  genre: string;
  subType: string | null;
  tone: string;
  targetWords: number | null;
  useKnowledge: boolean;
  productCode: string | null;
  topicHint: string | null;
  unreviewedPolicy: UnreviewedPolicy;
  dailyLimit: number;
  enabled: boolean;
  lastTopicError: string | null;
  counts: Record<ColumnItemStatus, number>;
  nextPlannedAt: string | null;
}

export interface ColumnItem {
  id: string;
  columnId: string;
  columnName: string | null;
  siteId: string;
  plannedAt: string;
  title: string;
  angle: string | null;
  keywords: string[];
  status: ColumnItemStatus;
  draftId: string | null;
  articleId: string | null;
  publicationId: string | null;
  publicationStatus: string | null;
  siteUrl: string | null;
  postponed: number;
  lastError: string | null;
  /** 1009 D:待审 / 已确认的稿件标题或正文带「官网栏目」这类写作说明字样时的提示(改掉就没了)。 */
  warning?: string | null;
}

export interface ColumnDetail {
  column: SiteColumn;
  items: ColumnItem[];
}

export interface ColumnRequest {
  siteId: string;
  name: string;
  weekdays: number[];
  publishTime: string;
  totalCount?: number | null;
  endDate?: string | null;
  genre: string;
  subType?: string | null;
  tone?: string | null;
  targetWords?: number | null;
  useKnowledge?: boolean;
  productCode?: string | null;
  topicHint?: string | null;
  unreviewedPolicy?: UnreviewedPolicy;
  dailyLimit?: number;
  enabled?: boolean;
}

export interface TopicRequest {
  title: string;
  angle?: string | null;
  keywords?: string[];
}

const BASE = "/tenant/reporter";

export const reporterColumnService = {
  list: () => api.get<SiteColumn[]>(`${BASE}/site-columns`),
  detail: (id: string) => api.get<ColumnDetail>(`${BASE}/site-columns/${id}`),
  create: (req: ColumnRequest) => api.post<ColumnDetail>(`${BASE}/site-columns`, req),
  update: (id: string, req: ColumnRequest) =>
    api.post<ColumnDetail>(`${BASE}/site-columns/${id}`, req),
  setEnabled: (id: string, enabled: boolean) =>
    api.post<ColumnDetail>(`${BASE}/site-columns/${id}/enabled`, { enabled }),
  remove: (id: string) => api.delete<void>(`${BASE}/site-columns/${id}`),
  /** 立即补选题(不扣费)。 */
  roll: (id: string) => api.post<ColumnDetail>(`${BASE}/site-columns/${id}/roll`, null),

  updateTopic: (itemId: string, req: TopicRequest) =>
    api.post<ColumnDetail>(`${BASE}/site-column-items/${itemId}/topic`, req),
  removeItem: (itemId: string) => api.delete<void>(`${BASE}/site-column-items/${itemId}`),
  /** 立即生成(按新闻舱现有口径扣费)。 */
  generate: (itemId: string) =>
    api.post<ColumnDetail>(`${BASE}/site-column-items/${itemId}/generate`, null),
  /** 确认并按计划发布。 */
  confirm: (itemId: string, confirm = false) =>
    api.post<ColumnItem>(`${BASE}/site-column-items/${itemId}/confirm`, { confirm }),
  /** 这篇稿是不是栏目条目(不是 → null)。 */
  byDraft: (draftId: number | string) =>
    api.get<ColumnItem | null>(`${BASE}/site-column-items/by-draft/${draftId}`),
};
